export const home1 = require('./home1.mp4')
export const home2 = require('./home2.mp4')
export const home3 = require('./home3.mp4')
export const home4 = require('./home4.mp4')